'use strict';

module.exports = function (string) {
  return string.replace(/^[\r\n]+/, '').replace(/[\r\n]+$/, '');
};

module.exports.start = function (string) {
  return string.replace(/^[\r\n]+/, '');
};

module.exports.end = function (string) {
  return string.replace(/[\r\n]+$/, '');
};